module.exports = __webpack_public_path__ + "static/img/zhuanti4.73264b6e.png";